<template>
  <div class="pa-3">
    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="model.name"
          variant="outlined"
          label="Nome"
          :rules="[rules.required]"
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="model.login"
          variant="outlined"
          label="Login"
          :rules="[rules.required]"
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="model.email"
          variant="outlined"
          label="E-mail"
          :rules="[rules.required]"
          type="email"
          :readonly="readonly"
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          v-model="model.active"
          :items="status"
          item-text="title"
          item-value="value"
          variant="outlined"
          label="Status"
          :readonly="readonly"
        />
      </v-col>
      <template v-if="!readonly">
        <v-col cols="12" md="4">
          <v-text-field
            v-model="model.password"
            variant="outlined"
            label="Senha"
            :rules="editing ? [] : [rules.required]"
            type="password"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="confirmPassword"
            variant="outlined"
            label="Confirme a senha"
            :rules="editing ? [] : [rules.equals(model.password, 'As senhas não correspondem')]"
            type="password"
          />
        </v-col>
      </template>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-autocomplete
          v-model="model.producer_ids"
          :items="producerItems"
          variant="outlined"
          label="Produtores"
          :rules="editing ? [] : [rules.producers]"
          :readonly="readonly"
          multiple
          chips
        >
          <template #prepend-item>
            <v-list-item
              title="Selecionar Todos"
              @click="toggle"
            >
              <template #prepend>
                <v-checkbox-btn
                  :indeterminate="hasSomeProducers && !hasAllProducers"
                  :model-value="hasAllProducers"
                />
              </template>
            </v-list-item>
            <v-divider class="mt-2" />
          </template>
          <template #no-data>
            <div class="pa-3">
              Produtor não encontrado.
            </div>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, Ref } from 'vue'
import { useProducerStore } from '@/stores/producer'
import { equals } from '@/helpers/rules/equals'
import { AdminUpdateRequest } from '@/services/AdminService'

const status = [ { title: 'Ativo', value: true }, { title: 'Inativo', value: false } ]

interface Props {
  readonly: boolean
  editing: boolean
}

const { readonly, editing } = defineProps<Props>()

const model = defineModel<AdminUpdateRequest>({ required: true })

const confirmPassword: Ref<string> = ref('')

const rules = {
  required: (v: string) => (!!v || readonly || v == String(false)) || 'Campo obrigatório',
  producers: (v: string) => v.length > 0 || 'Selecione pelo menos um produtor',
  equals,
}

const producers = computed(() => useProducerStore().producers.filter(p => p.status === 'active'))

const producerItems = computed(() => {
  return [
    ...producers.value,
    ...(model.value.producers ?? []).filter(a => !producers.value.some(b => a.id === b.id)),
  ].map((p) => {
    return { title: p.data.trade_name, value: p.id }
  })
})

const hasSomeProducers = computed(() => {
  return model.value.producer_ids.length > 0
})

const hasAllProducers = computed(() => {
  return model.value.producer_ids.length === producerItems.value.length
})

function toggle() {
  if (hasAllProducers.value) {
    model.value.producer_ids = []
  } else {
    model.value.producer_ids = producerItems.value.map(p => p.value)
  }
}
</script>
